const state = () => ({
    all: [],
})

const getters = {
    // mainFilters: (state, getters, rootState, rootGetters)
    filterTitles: (state) => state.all.filter(function (logicFilter) {
        return logicFilter.type !== 'fl_cat_select' && (logicFilter.isOpen || logicFilter.values.length > 1)
    }).map((logicFilter) => ({
            id: logicFilter.fl_filterid,
            type: logicFilter.type,
            displayName: logicFilter.displayName,
            isActive: logicFilter.isActive,
            isOpen: logicFilter.isOpen,
            fl_buttons_showMore: logicFilter.fl_buttons_showMore,
            fl_buttons_submit: logicFilter.fl_buttons_submit,
            fl_buttons_reset: logicFilter.fl_buttons_reset,
            rangeTotal: logicFilter.totalRange,
            rangeSelected: logicFilter.selectedRange,
            rangeUnit: logicFilter.unit,
            rangeDecimals: logicFilter.rangeDecimals
        })
    ),

    // mainFilters: (state, getters, rootState, rootGetters)
    categoryTitles: (state) => state.all.filter(function (logicFilter) {
        // WEB-728: Hide Categories
        // const isMobile = (util.handleResize() !== 'large');
        // return !isMobile && logicFilter.type === 'fl_cat_select'
        logicFilter;
        return false;
    }).map((logicFilter) => ({
            id: logicFilter.fl_filterid,
            type: logicFilter.type,
            displayName: logicFilter.displayName,
            isOpen: logicFilter.isOpen,
            fl_buttons_showMore: logicFilter.fl_buttons_showMore
        })
    ),

    values: (state) => (index) => {
        const logicFilter = state.all[index];

        if (logicFilter.isOpen === false) {
            return []
        }

        if (logicFilter.type === 'label' || logicFilter.type === 'select' || logicFilter.type === 'fl_cat_select') {
            return logicFilter.values.filter((item, index) =>
                logicFilter.showFilterValue || index < logicFilter.pinnedFilterValueCount
            )
        }

        return logicFilter.values
    },

    specification: (state) => (index) => {
        const logicFilter = state.all[index];
        return {
            id: index,
            name: logicFilter.name,
            combinationOperation: logicFilter.combinationOperation,
        }
    },

    selectedValues: (state) => {
        const selectedValues = [];

        state.all.forEach((logicFilter, index) => {
            logicFilter.values.filter(function (logicValue) {
                return logicValue.isActive
            }).map((logicValue) => {
                selectedValues.push({
                    filter_id: index,
                    name: logicFilter.name,
                    value: logicValue.value
                });
            })
        });

        return selectedValues;
    }
}

const actions = {
    init({commit}, {filters, display}) {
        commit('setFilters', {filters, display})
    },

    toggleFilterBox({commit}, logicFilterId) {
        commit('displayFilterBox', {logicFilterId});
    },

    toggleCategoryBox({commit}, logicCategories) {
        commit('displayCategoryBox', {logicCategories});
    },

    togglePinnedItems({commit}, logicFilterId) {
        commit('displayAllFilterItems', {logicFilterId});
    },
}

const mutations = {
    setFilters(state, {filters, display}) {
        const isMobile = (util.handleResize() !== 'large')
        filters.main.map((logicFilter) => {
            logicFilter.isActive = logicFilter.values.find((value) => value.selected) !== undefined || (!isMobile && display === 'articlelist')
            logicFilter.isOpen = logicFilter.isActive
            logicFilter.values.map((logicValue) => logicValue.isActive = logicValue.selected)
        })
        filters.other.map((logicFilter) => {
            if (logicFilter.type === 'range-slider') {
                logicFilter.isActive = Object.entries(logicFilter.selectedRange).toString() !== Object.entries(logicFilter.totalRange).toString() || (!isMobile && display === 'articlelist')
                logicFilter.isOpen = logicFilter.isActive
                logicFilter.rangeDecimals = 0
                logicFilter.values.map((logicValue) => {
                    if (!Number.isInteger(logicValue.value)) {
                        let decimalStr = logicValue.value.toString().split('.')[1];
                        if (decimalStr.length > logicFilter.rangeDecimals) {
                            logicFilter.rangeDecimals = decimalStr.length;
                        }
                    }
                })
            } else {
                logicFilter.isActive = logicFilter.values.find((value) => value.selected) !== undefined || (!isMobile && display === 'articlelist')
                logicFilter.isOpen = logicFilter.isActive
                logicFilter.values.map((logicValue) => logicValue.isActive = logicValue.selected)
            }
        })

        const init = [...filters.main, ...filters.other]
        init.map((logicFilter) => logicFilter.showFilterValue = false)

        state.all = init
    },

    displayFilterBox(state, {logicFilterId}) {
        if (!state.all[logicFilterId].isOpen) {
            state.all[logicFilterId].isOpen = true;
        }
    },

    displayCategoryBox(state, {logicCategories}) {
        logicCategories.map((logicFilter) => state.all[logicFilter.id].isOpen = !state.all[logicFilter.id].isOpen)
    },

    displayAllFilterItems(state, {logicFilterId}) {
        state.all[logicFilterId].showFilterValue = !state.all[logicFilterId].showFilterValue
    },

    selectValue(state, {spec, filter, isSelected}) {
        if (spec.combinationOperation !== 'or') {
            state.all[spec.id].values.map((value) => value.selected = false)
        }

        filter.selected = isSelected
    },
}

const util = {
    defaultBreakpoints: {
        small: 744,
        medium: 1060,
        large: Infinity
    },
    handleResize() {
        const clientWidth = window.innerWidth
        if (clientWidth < util.defaultBreakpoints.small) {
            return 'small'
        } else if (clientWidth < util.defaultBreakpoints.medium) {
            return 'medium'
        } else if (clientWidth <= util.defaultBreakpoints.large) {
            return 'large'
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
